/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

export const CardGrid = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(12, 1fr);

  > * {
    grid-column: span ${({ $span }) => $span || 12};
  }

  @media (min-width: 768px) {
    gap: 16px;
    > * {
      grid-column: span ${({ $mdSpan }) => $mdSpan || 6};
    }
  }

  @media (min-width: 1024px) {
    > * {
      grid-column: span ${({ $lgSpan }) => $lgSpan || 4};
    }
  }
`;

export const MiniCard = styled.div`
   border: 1px solid
      ${({ theme }) => theme?.colors?.border ?? 'rgba(0,0,0,0.08)'};
   border-radius: 12px;
   padding: 12px;
   background: ${({ theme }) => theme?.colors?.surface ?? '#fff'};
   box-shadow: ${({ theme }) =>
      theme?.shadows?.sm ?? '0 1px 2px rgba(0,0,0,0.04)'};
`;

export const MiniCardTitle = styled.div`
   font-size: 12px;
   color: ${({ theme }) => theme?.colors?.textMuted ?? '#666'};
   margin-bottom: 6px;
`;

export const MiniCardValue = styled.div`
   font-size: 20px;
   font-weight: 700;
   color: ${({ theme }) => theme?.colors?.textPrimary ?? '#111'};
`;
